import React, { FC } from 'react';
import { ImageI } from 'core/interface/image';

const Image: FC<ImageI> = ({
  className,
  name,
  url,
  width = 15,
  height = 'auto',
  onClick,
  objectFit = 'contain',
  style
}) => {
  return (
    <img
      onClick={() => onClick}
      className={className}
      src={url ?? `/static/images/${name}`}
      alt={name ?? 'img'}
      width={width}
      height={height}
      style={{ objectFit: objectFit as 'contain' | 'cover', ...style }}
    />
  );
};

export default Image;
